import { useMemo } from "react";

import { useAthlete } from "./queries/useAthletes";
import {
  useAthleteCareer,
  useAthletePreferences,
  useLatestAthleteTracking,
} from "./queries/useAthleteData";

// Detalle de atleta para el scout/coach: compone el row del atleta con la
// última evaluación, preferencias y el último valor de cada sección de tracking
// (los scouts tienen acceso de lectura a todos estos recursos). Cada fila diaria
// solo guarda lo que se escribió ese día, así que "la fila más nueva" puede no
// tener entrenamiento: /latest arma cada sección desde su propia fila.
export const useCoachAthlete = (athleteId) => {
  const athleteQuery = useAthlete(athleteId);
  const careerQuery = useAthleteCareer(athleteId);
  const preferencesQuery = useAthletePreferences(athleteId);
  const trackingQuery = useLatestAthleteTracking(athleteId);

  const isLoading =
    athleteQuery.isLoading ||
    careerQuery.isLoading ||
    preferencesQuery.isLoading ||
    trackingQuery.isLoading;

  const error =
    athleteQuery.error ||
    careerQuery.error ||
    preferencesQuery.error ||
    trackingQuery.error ||
    null;

  const athlete = useMemo(() => {
    if (!athleteId || isLoading) return null;

    const athleteRow = athleteQuery.data || {};

    return {
      ...athleteRow,
      id: athleteRow.id || athleteId,
      athlete_id: athleteId,
      attributes: athleteRow.attributes || {},
      athlete_career: careerQuery.data ? [careerQuery.data] : [],
      athlete_preferences: preferencesQuery.data ? [preferencesQuery.data] : [],
      athlete_tracking: trackingQuery.data ? [trackingQuery.data] : [],
    };
  }, [
    athleteId,
    isLoading,
    athleteQuery.data,
    careerQuery.data,
    preferencesQuery.data,
    trackingQuery.data,
  ]);

  return { athlete, isLoading, error };
};
